import React, { useContext, useEffect, useState } from 'react'
import { message, Spin } from 'antd';
import { Route, useHistory, useLocation } from 'react-router-dom'
import { useAuth } from '../services/AuthService';
import constants from '../constants/constants';
import Cookies from 'js-cookie';
import APIUtils from '../api/APIUtils';
import WebLinks from '../api/WebLinks';
import { CommonContext } from '../Context';
/**
 *
 * @param {Object} Route parameters
 * @description Route parameters must contain layout, component and other props. Layout has to be the master oage.
 */
export function RouteWithLayout({ layout, auth, component, path, ...rest }) {
    const{ isUserAuthed }=useAuth();
    const history = useHistory();
    const location = useLocation();
    const commonContext = useContext(CommonContext);
    const loggedInBuyerId = Cookies.get(constants.COOKIE_LOGGED_BUYER_ID);
    const selectedBuyerId = commonContext.common?.buyerId || loggedInBuyerId;
    const [accessCheck, setAccessCheck] = useState({ pathname: null, allowed: false });
    const isAuthed = Boolean(isUserAuthed());
    // useEffect(() => {
    //     //URL handled when the menu items change due to subBuyerAdmin
    //         if ((sessionStorage.getItem('selectedissubbuyeradmin') && sessionStorage.getItem('selectedissubbuyeradmin')?.toString()==="true" && ( path === '/' || path !== '/multi-budget-admin' && path !== '/multi-supplier-admin' && path !== '/multi-application-report'  && path !== '/multi-job-admin' && path!=='/multi-candidate-admin'  && path!=='/multi-budgets' && path!=='/multi-click-report' && path!=='/multi-dashboard'  && path!=='/multi-cost-center' && path!=='/multi-priority-filters' && path!=='/multi-priority-rules' && path!=='/your-jobs-admin' && path!=='/boost-orders-admin' && path!=='/boost-orders-finance' && path!=='/multi-orders' && path!=='/multi-billing-finance' && path!=='/multi-orders-admin-cs' && path!=='/multi-orders-admin' && path!=='/landing-page')) ||
    //         ( sessionStorage.getItem('selectedissubbuyeradmin') && sessionStorage.getItem('selectedissubbuyeradmin')?.toString()==="false" && ( path === '/' || path === '/multi-budget-admin' || path === '/multi-supplier-admin' || path === '/multi-application-report' || path === '/multi-job-admin' || path==='/multi-candidate-admin' || path==='/multi-budgets' || path==='/multi-click-report' || path==='/multi-dashboard' || path==='/multi-cost-center' || path==='/multi-priority-filters' || path==='/multi-priority-rules' || path==='/your-jobs-admin' || path==='/boost-orders-admin' || path==='/boost-orders-finance' ||	path==='/multi-orders' ||	path==='/multi-billing-finance' ||	path==='/multi-orders-admin-cs' ||	path==='/multi-orders-admin' ))) {
    //             if(path!=='/DownloadFile' && path!=='/settings' &&  path!=='/activity-logs' && path!=='/bulk-hire'&& path!=='/set-bulk-hire' &&	path!=='/chatbotdomainconfigure' &&	path!=='/set-bulk-interview' &&	path!=='/orders' &&	path!=='/billing-finance' &&	path!=='/orders-admin-cs' &&	path!=='/orders-admin'  && path!=='/welcome'){
    //                 history.replace("/");
    //             }
    //         }
    //   }, [path, history]);

    let selectedComponent = component;
    // if (cookieValue === "true") {
    //     if(path === '/' || path === '/welcome' || (path !== '/multi-budget-admin' && path !== '/multi-supplier-admin' && path !== '/multi-application-report' && path !== '/multi-job-admin' && path !=='/multi-candidate-admin'  && path !=='/multi-budgets' && path!=='/multi-click-report' && path!=='/multi-dashboard' && path!=='/multi-cost-center' && path!=='/multi-priority-filters' && path!=='/multi-priority-rules' && path!=='/your-jobs-admin' && path!=='/boost-orders-admin' && path!=='/boost-orders-finance' && path!=='/multi-orders' && path!=='/multi-billing-finance' && path!=='/multi-orders-admin-cs' && path!=='/multi-orders-admin' && path!=='/landing-page')){
    //         if(path==='/DownloadFile'|| path==='/settings' || path==='/activity-logs'|| path==='/bulk-hire'|| path==='/set-bulk-hire'|| path==='/chatbotdomainconfigure' || path==='/set-bulk-interview' || path==='/orders' || path==='/billing-finance' || path==='/orders-admin-cs' || path==='/orders-admin' || path==='/welcome'){
    //             selectedComponent= component;
    //         }else{
    //             if(loggedInBuyer?.includes("hi admin")&&loggedInBuyer===SelectedBuyer){
    //                 selectedComponent = MultiCostCenter;
    //             }else if(Cookies.get(constants.COOKIE_IS_RECRUITER)===true||Cookies.get(constants.COOKIE_IS_RECRUITER)==="true"){
    //                 selectedComponent = MultiCandidateAdmin;
    //             }else{
    //                 selectedComponent = MultiYourJobsContainer;
    //             }
    //         }
    //     }
    // }else{
        if(path === '/welcome'){
            selectedComponent = component;
        // }else if(path === '/' || path === '/multi-budget-admin' || path === '/multi-supplier-admin' || path === '/multi-application-report' || path === '/multi-job-admin' || path ==='/multi-candidate-admin' || path ==='/multi-budgets' || path==='/multi-click-report' || path==='/multi-dashboard' || path==='/multi-cost-center' || path==='/multi-priority-filters' || path==='/multi-priority-rules' || path==='/your-jobs-admin' || path==='/boost-orders-admin' || path==='/boost-orders-finance' || path==='/multi-orders' || path==='/multi-billing-finance' || path==='/multi-orders-admin-cs' || path==='/multi-orders-admin' ){
        //     if(Cookies.get(constants.COOKIE_IS_RECRUITER)===true||Cookies.get(constants.COOKIE_IS_RECRUITER)==="true"){
        //         selectedComponent= Candidates;
        //     }else{
        //         selectedComponent = YourJobsContainer;
        //     }
        // }
    }

    useEffect(() => {
        let isActive = true;

        if (!isAuthed) {
            history.replace('/login');
            return () => {
                isActive = false;
            };
        }

        const pathname = location.pathname;
        if (pathname === '/login') {
            setAccessCheck({ pathname, allowed: true });
            return () => {
                isActive = false;
            };
        }

        setAccessCheck({ pathname, allowed: false });

        const checkPageAccess = async () => {
            const accessResponse = await APIUtils.apiCall(
                'GET',
                `${WebLinks.CheckBuyerPageAccess}${encodeURIComponent(loggedInBuyerId)}&selectedBuyerId=${encodeURIComponent(selectedBuyerId)}&pageURL=${encodeURIComponent(pathname)}`
            );

            if (!isActive) return;

            if (accessResponse.isCatch || !accessResponse.resultObj || accessResponse.resultObj.statusCode !== '2000' || typeof accessResponse.resultObj.hasPageAccess !== 'boolean') {
                message.error(accessResponse.resultObj?.message || constants.ERROR_MESSAGE);
                return;
            }

            if (accessResponse.resultObj.hasPageAccess) {
                setAccessCheck({ pathname, allowed: true });
                return;
            }

            message.error('Sorry, you do not have permission to access this page.');
            const menuResponse = await APIUtils.apiCall(
                'GET',
                `${WebLinks.GetBuyerMenu}${encodeURIComponent(loggedInBuyerId)}&selectedBuyerId=${encodeURIComponent(selectedBuyerId)}`
            );

            if (!isActive) return;

            if (menuResponse.isCatch || menuResponse.resultObj?.statusCode !== '2000') {
                message.error(menuResponse.resultObj?.message || constants.ERROR_MESSAGE);
                return;
            }

            const menuItems = Array.isArray(menuResponse.resultObj?.data)
                ? [...menuResponse.resultObj.data].sort((a, b) => (a.menuOrder ?? 999) - (b.menuOrder ?? 999))
                : [];
            const firstMenuItemPath = menuItems[0]?.pageURL;

            if (firstMenuItemPath && firstMenuItemPath !== pathname) {
                history.replace(firstMenuItemPath);
            }
        };

        checkPageAccess();
        return () => {
            isActive = false;
        };
    }, [history, isAuthed, location.pathname, loggedInBuyerId, selectedBuyerId]);

  return (
      <Route
          {...rest}
          render={(props) =>
              React.createElement(
                  layout,
                  {
                      ...props,
                      ...rest
                  },
                  accessCheck.pathname === location.pathname && accessCheck.allowed
                      ? React.createElement(selectedComponent, {
                          ...props,
                          ...rest
                      })
                      : React.createElement(Spin, { className: 'flex justify-center mt-10' })
              )
          }
      />
      
  );
}
